<template>
  <DatatableReportV3
    id="quotes-table"
    ref="quote_datatable"
    title="Quotes"
    :source="source"
    :config="config"
    :filters="filters"
  />
</template>

<script>
import { EventBus } from "@/lib/event_bus.js";

import Badge from "@/components/Badge.vue";
import CONSTANTS from "@/Constants";
import QuoteActionsContextMenu from "@/Customer/Profile/QuoteActionsContextMenu.vue";
import JobOpportunityLink from "@/Job/Opportunity/JobOpportunityLink.vue";
import DatatableReportV3 from "@/Reports/DatatableReportV3.vue";
import TagList from "@/Tags/TagList.vue";
import store from "@/vuex/store";

export default {
  components: {
    DatatableReportV3
  },
  props: {
    source: {
      type: String,
      default: ""
    },
    filters: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      config: {
        order: [[0, "desc"]],
        columns: [
          {
            data: "quote_date",
            title: "Date"
          },
          { data: "quote_link", title: "Quote" },
          {
            data: "sent_at",
            title: "Sent",
            orderable: false,
            className: "quote-sent-badge"
          },
          { data: "created_by", title: "Created By" },
          { data: "customer" },
          { data: "customer_email", title: "Email" },
          { data: "customer_phone", title: "Phone" },
          {
            data: "quote_status",
            orderData: 4,
            orderable: true,
            searchable: false,
            title: "Status"
          },
          { data: "alpha_status", visible: false, searchable: false },
          { data: "location_name", title: "Location Name" },
          {
            data: "service_address",
            title: "Service Address",
            orderable: false
          },
          { data: "job" },
          { data: "department", title: "Department" },
          { data: "tags", title: "Tags", orderable: false },
          { data: "invoice_link", title: "Invoice" },
          { data: "name" },
          { data: "summary" },
          {
            data: "item_count",
            title: "Items",
            className: "text-center",
            searchable: false
          },
          {
            data: "promo_code",
            title: "Promo Code",
            filterName: "promo_code"
          },
          {
            data: "promo_code_amount",
            title: "Promo Code Amount",
            className: "text-right",
            searchable: false
          },
          {
            data: "total_cents",
            title: "Total",
            className: "text-right",
            searchable: false,
            aggregateTitle: CONSTANTS.AGGREGATE_HEADERS.total,
            footerClassName: "text-right"
          },
          {
            data: "actions",
            title: "",
            orderable: false,
            className: "text-center th-no-text",
            searchable: false
          }
        ],
        vueComponents: [
          {
            rootId: "job-opportunity-modal-vue",
            component: JobOpportunityLink,
            options: {
              store
            }
          },
          {
            rootId: "quote-context-menu-vue",
            component: QuoteActionsContextMenu,
            options: {
              store
            }
          },
          {
            rootId: "tag-list-vue",
            component: TagList
          },
          {
            rootId: "badge-vue",
            component: Badge
          }
        ]
      }
    };
  },
  mounted() {
    EventBus.$on("refresh-quote-datatable", this.refreshData);
    EventBus.$on("datatable-edit-quote", this.redirectToQuote);
  },
  beforeUnmount() {
    EventBus.$off("refresh-quote-datatable", this.refreshData);
    EventBus.$off("datatable-edit-quote", this.redirectToQuote);
  },
  methods: {
    refreshData() {
      this.$refs.quote_datatable.refreshTable();
    },
    redirectToQuote({ quoteId, customerId }) {
      window.location = `/customers/${customerId}?quote_id=${quoteId}&tab=c_Quotes&editing=true`;
    }
  }
};
</script>

<style lang="scss" scoped>
:deep(.quote-sent-badge .sera-badge) {
  margin-left: 0px;
  justify-content: center !important;
}
::v-deep td .delegated-icon {
  display: none;
}
</style>
